import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BASE_URL from "../../../../config/config";

export default function EditTag() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [csrfToken, setCsrfToken] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    // دریافت CSRF Token
    fetch(`${BASE_URL}/csrf-token`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setCsrfToken(data.csrfToken));

    // دریافت اطلاعات تگ
    fetch(`${BASE_URL}/blog/tags/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch tag");
        return res.json();
      })
      .then((data) => {
        
        if (data.success && data.data) {
          setFormData({
            name: data.data.name,
            slug: data.data.slug,
          });
        } else {
          throw new Error("Invalid data structure");
        }
      })
      .catch((err) => {
        console.error("Error loading tag:", err);
        setMessage("خطا در دریافت اطلاعات تگ");
      })
      .finally(() => {
        setIsLoadingData(false);
      });
  }, [id]);

  const generateSlug = (text) => {
    return text
      ? text
          .replace(/[\s]+/g, "_")
          .replace(/[^\u0600-\u06FFa-zA-Z0-9_]/g, "")
          .replace(/_+/g, "_")
          .replace(/^_+|_+$/g, "")
      : "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setFormData((prev) => ({
      ...prev,
      name,
      slug: generateSlug(name),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    if (!formData.name.trim()) {
      setErrors({ name: "نام تگ الزامی است" });
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/blog/tags/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "خطا در ویرایش تگ");

      setMessage("تگ با موفقیت ویرایش شد");
      setTimeout(() => navigate("/admin/blog/tags"), 1500);
    } catch (err) {
      setMessage(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoadingData) {
    return <div className="loading">در حال بارگذاری اطلاعات تگ...</div>;
  }

  return (
    <div className="tag-form-container">
      <h2>ویرایش تگ</h2>
      
      {message && (
        <div className={`alert ${message.includes("موفق") ? "success" : "error"}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>نام تگ *</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            className={errors.name ? "error" : ""}
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label>Slug *</label>
          <input
            name="slug"
            value={formData.slug}
            onChange={(e) => handleChange({ 
              target: { 
                name: "slug", 
                value: generateSlug(e.target.value) 
              } 
            })}
            className={errors.slug ? "error" : ""}
          />
          {errors.slug && <span className="error-text">{errors.slug}</span>}
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? "در حال ذخیره..." : "ذخیره تغییرات"}
          </button>
          <button type="button" onClick={() => navigate("/admin/blog/tags")}>
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}